import React from "react";
import { Editor } from "@tinymce/tinymce-react";

const TinyMceEditor = ({ value, onChange, editorRef, height = 400 }) => {
  return (
    <Editor
      tinymceScriptSrc="https://cdn.tiny.cloud/1/23ecdyf4j6wrgb6682fhy7sr995s8sf363y9vzh5wn4n0loj/tinymce/6/tinymce.min.js"
      value={value}
      onEditorChange={onChange}
      onInit={(evt, editor) => {
        if (editorRef) editorRef.current = editor;
      }}
      init={{
        height,
        menubar: "edit view format insert",
        branding: false,
        promotion: false,
        plugins: "link lists image code table",
        toolbar: "bullist numlist | table",
        statusbar: false,
        skin: "oxide",
        content_css: "default"
      }}
    />
  );
};

export default TinyMceEditor;
